
export default {
  props: ['title', 'url', 'featured_image']
}
